"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HTTPEvent = exports.Backend = exports.APIPrefix = exports.HTTP = void 0;
const config_1 = require("@completeanatomy/config");
const store_1 = require("@completeanatomy/store");
const eventemitter3_1 = require("eventemitter3");
const lodash_isequal_1 = __importDefault(require("lodash.isequal"));
const redux_watch_1 = __importDefault(require("redux-watch"));
require("reflect-metadata");
const typedi_1 = require("typedi");
const HTTPEvent_1 = require("./types/HTTPEvent");
Object.defineProperty(exports, "HTTPEvent", { enumerable: true, get: function () { return HTTPEvent_1.HTTPEvent; } });
const backend_1 = require("./types/backend");
Object.defineProperty(exports, "Backend", { enumerable: true, get: function () { return backend_1.Backend; } });
const fetchOptions_1 = require("./types/fetchOptions");
Object.defineProperty(exports, "APIPrefix", { enumerable: true, get: function () { return fetchOptions_1.APIPrefix; } });
const method_1 = require("./types/method");
/**
 * @TODO - Add support of User data API
 */
let HTTP = class HTTP extends eventemitter3_1.EventEmitter {
    constructor(config, store) {
        super();
        this.config = config;
        this.store = store;
        this.accessTokenIsRefreshed = null;
    }
    /**
     * Method uses fetch() for making API requests
     *
     * @param path - API patch (for example: `user/info`)
     * @param method - HTTP request method
     * @param data - request data
     * @param version - version of API
     * @param lang - Accept-Language header value
     * @param backend
     * @param apiPrefix
     * @param header
     *
     * @private
     */
    fetch({ path, method, data, version = 13, lang, backend = backend_1.Backend.Default, apiPrefix = fetchOptions_1.APIPrefix.API, header = {}, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = this.createUrl({
                backend,
                path,
                version,
                apiPrefix,
            });
            const options = this.createFetchOptions({
                method,
                lang,
                data,
                header,
            });
            const response = yield fetch(url, options);
            if (response.ok) {
                return response;
            }
            // @todo - create error object, don't use response here
            this.emit(HTTPEvent_1.HTTPEvent.Error, response.clone());
            try {
                const clonedResponse = response.clone();
                /**
                 * Try to parse response as JSON
                 * Some errors may not have JSON body
                 */
                const clonedResponseData = yield clonedResponse.json();
                if (clonedResponse.status === 401 &&
                    clonedResponseData.detail === 'expired token') {
                    // eslint-disable-next-line max-depth
                    if (this.accessTokenIsRefreshed === null) {
                        this.accessTokenIsRefreshed = new Promise(resolve => {
                            /**
                             * Subscribe to access token changes in the state
                             * If there is a new access token, retry request
                             */
                            const watcher = (0, redux_watch_1.default)(this.store.getState, 'auth', lodash_isequal_1.default);
                            const unsubscribe = this.store.subscribe(watcher((newValue, oldValue) => {
                                if (newValue &&
                                    newValue.accessToken &&
                                    newValue.accessToken !== (oldValue === null || oldValue === void 0 ? void 0 : oldValue.accessToken)) {
                                    unsubscribe();
                                    this.accessTokenIsRefreshed = null;
                                    resolve();
                                }
                            }));
                        });
                    }
                    yield this.accessTokenIsRefreshed;
                    const updatedOptions = this.createFetchOptions({
                        method,
                        lang,
                        data,
                    });
                    return fetch(url, updatedOptions);
                }
            }
            catch (e) {
                console.log('[HTTP]', e);
            }
            return response;
        });
    }
    /**
     * Make GET request
     *
     * @param options - request options
     */
    get(options) {
        return this.fetch(Object.assign(Object.assign({}, options), { method: method_1.Method.Get }));
    }
    /**
     * Make POST request
     *
     * @param options - request options
     */
    post(options) {
        return this.fetch(Object.assign(Object.assign({}, options), { method: method_1.Method.Post }));
    }
    /**
     * Make PUT request
     *
     * @param options - request options
     */
    put(options) {
        return this.fetch(Object.assign(Object.assign({}, options), { method: method_1.Method.Put }));
    }
    /**
     * Make PATCH request
     *
     * @param options - request options
     */
    patch(options) {
        return this.fetch(Object.assign(Object.assign({}, options), { method: method_1.Method.Patch }));
    }
    /**
     * Make DELETE request
     *
     * @param options - request options
     */
    delete(options) {
        return this.fetch(Object.assign(Object.assign({}, options), { method: method_1.Method.Delete }));
    }
    /**
     * Creates URL string by provided backend, path, and API version
     *
     * @param backend
     * @param path
     * @param version
     *
     * @private
     */
    createUrl({ backend, path, version, apiPrefix, }) {
        let backendUrl;
        switch (backend) {
            case backend_1.Backend.None:
                backendUrl = '';
                break;
            case backend_1.Backend.SSO:
                backendUrl = this.config.get('SSO_BACKEND');
                break;
            case backend_1.Backend.S3UserData:
                backendUrl = this.config.get('AWS_SERVER_S3_USERDATA');
                break;
            case backend_1.Backend.Default:
            default:
                backendUrl = this.config.get('AWS_SERVER_BACKEND');
                break;
        }
        if (apiPrefix === fetchOptions_1.APIPrefix.None) {
            return `${backendUrl}${path}`;
        }
        return `${backendUrl}${apiPrefix}/v${version}/${path}`;
    }
    /**
     * Creates options for fetch() in RequestInit format
     *
     * @param method
     * @param lang
     * @param data
     * @param header
     *
     * @private
     */
    createFetchOptions({ method, lang, data, header, }) {
        const options = {
            method,
        };
        const { deviceInformation } = this.store.getState();
        const acceptLanguage = lang || (deviceInformation === null || deviceInformation === void 0 ? void 0 : deviceInformation.language) || 'en';
        const bundleId = deviceInformation === null || deviceInformation === void 0 ? void 0 : deviceInformation.bundleID;
        let accessToken;
        try {
            accessToken = this.config.get('accessToken');
        }
        catch (e) {
            console.log('[HTTP]', e);
        }
        const headers = new Headers(Object.assign(Object.assign({}, header), { 'Accept-Language': acceptLanguage }));
        if (accessToken) {
            headers.set('Authorization', `Bearer ${accessToken}`);
        }
        if (bundleId) {
            headers.set('bundle', bundleId);
        }
        if (data && method !== method_1.Method.Get) {
            options.body = JSON.stringify(data);
            headers.append('Content-Type', 'application/json; charset=utf-8;');
        }
        options.headers = headers;
        return options;
    }
};
exports.HTTP = HTTP;
/**
 * Name of exported module property
 */
HTTP.exportName = 'http';
exports.HTTP = HTTP = __decorate([
    (0, typedi_1.Service)(),
    __param(1, (0, typedi_1.Inject)(store_1.StoreToken)),
    __metadata("design:paramtypes", [config_1.Config, Object])
], HTTP);
